<template>
	<div class="info-content">
		<el-form label-width="80px">
			<el-form-item label="页面标题">
				<el-input v-model="list.title"></el-input>
			</el-form-item>
			<el-form-item label="页面备注">
				<el-input type="textarea" :rows="4" v-model="list.remarks"></el-input>
			</el-form-item>
			<el-form-item label="背景颜色">
				<el-color-picker v-model="list.backgroundColor" show-alpha></el-color-picker>
			</el-form-item>
			<el-form-item label="背景图片">
				<el-button v-if="list.backgroundImage != ''" type="danger" icon="el-icon-delete" size="small" round @click="removeImage">删除图片</el-button>
				<el-upload
					class="avatar-uploader"
					:action="'https://app.kcguoyi.com/api/service/upload/uploadImage'"
					:auto-upload="false"
					:show-file-list="false"
					:on-change="handleImport"
					accept="image/gif,image/jpeg,image/jpg,image/png"
					drag
				>
					<img v-if="list.backgroundImage != ''" :src="list.backgroundImage" class="avatar" />
					<i v-else class="el-icon-upload"></i>
					<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
				</el-upload>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
import axios from 'axios';
export default {
	name: 'Info',
	props: ['data', 'className'],
	data() {
		return {
			list: {},
		};
	},
	mounted() {
		this.list = this.data;
	},
	methods: {
		//删除图片
		removeImage() {
			this.list.backgroundImage = '';
		},
		//图片上传
		handleImport(file, fileList) {
			if (fileList.length > 1) {
				fileList.splice(0, 1);
			}
			const params = new FormData();
			params.append('file', file.raw);
			var loading = this.$loading({
				lock: true,
				text: '图片上传中',
			});
			var url = 'https://app.kcguoyi.com/api/service/upload/uploadImage';
			axios
				.post(url, params, {
					headers: { 'Content-Type': 'multipart/form-data' },
				})
				.then((res) => {
					const data = {
						name: res.data.body[0].name,
						url: res.data.body[0].url,
					};
					// this.list.data = [];
					this.list.backgroundImage = res.data.body[0].url;
				})
				.finally(() => {
					this.$nextTick(() => {
						this.$forceUpdate();
					});
					loading.close();
				});
		},
	},
};
</script>

<style  scoped>
.info-content {
	padding: 20px;
}
div /deep/ .el-upload-dragger {
	width: 220px;
	height: 140px;
}
div /deep/ .el-upload-dragger .el-icon-upload {
	margin-top: 20px;
}
.avatar {
	width: 220px;
	height: 140px;
	display: block;
}
</style>